import { auth } from '../firebase/config';

export interface ChangePasswordRequest {
    newPassword: string;
}

export interface ChangePasswordResponse {
    success: boolean;
    message: string;
}

/**
 * Change the password for the currently authenticated user
 * Uses the PHP endpoint configured in REACT_APP_CHANGE_PASSWORD_ENDPOINT
 */
export async function changePassword(newPassword: string): Promise<ChangePasswordResponse> {
    const endpoint = process.env.REACT_APP_CHANGE_PASSWORD_ENDPOINT;
    
    if (!endpoint) {
        throw new Error('REACT_APP_CHANGE_PASSWORD_ENDPOINT is not configured in .env file');
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
        throw new Error('No user is currently logged in');
    }

    // Get the current user's ID token
    const idToken = await currentUser.getIdToken();

    const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            idToken,
            newPassword,
        }),
    });

    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || data.error || 'Failed to change password');
    }

    return {
        success: data.success || true,
        message: data.message || 'Password changed successfully',
    };
}
